import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from 'src/environments/environment';
import { catchError, throwError } from 'rxjs';
import { LoaderService } from './loader/loader.service';

@Injectable({
	providedIn: 'root',
})
export class DataBagService {
	constructor(
		private readonly http: HttpClient,
		private readonly loader: LoaderService,
	) {}

	get(url: string, callback) {
		this.http
			.get(environment.apiUrl + url)
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe((result) => {
				callback(result, false);
			});
	}

	put(url: string, data: object, callback) {
		this.http
			.put(environment.apiUrl + url, data)
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe((result) => {
				callback(result, false);
			});
	}

	post(url: string, data: object, callback) {
		this.http
			.post(environment.apiUrl + url, data)
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe((result) => {
				callback(result, false);
			});
	}

	postBlob(url: string, data: object, callback) {
		this.http
			.post(environment.apiUrl + url, data, { responseType: 'blob' })
			.pipe(
				catchError((error: any) => {
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe((result) => {
				callback(result, false);
			});
	}

	patch(url: string, data: object, callback) {
		this.http
			.patch(environment.apiUrl + url, data)
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe(
				(result) => {
					callback(result, false);
				},
				(error) => this.parseErrors(error, callback),
			);
	}

	del(url: string, callback) {
		this.http
			.delete(environment.apiUrl + url)
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe(
				(result) => {
					callback(result, false);
				},
				(error) => {
					if (error.status == 401) {
						return;
					}
					callback(false, error);
				},
			);
	}
	delete(url: string, data, callback) {
		this.http
			.delete(environment.apiUrl + url, {
				body: data,
			})
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe(
				(result) => {
					callback(result, false);
				},
				(error) => {
					if (error.status == 401) {
						return;
					}
					callback(false, error);
				},
			);
	}

	upload(url: string, file: File, callback) {
		const formData = new FormData();
		formData.append('name', file.name);
		formData.append('file', file);
		return this.http
			.post(environment.apiUrl + url, formData, {
				reportProgress: true,
			})
			.pipe(
				catchError((error) => {
					this.loader.hide();
					callback(false, error);
					return throwError(() => error);
				}),
			)
			.subscribe(
				(result) => {
					callback(result, false);
				},
				(error) => {
					if (error.status == 401) {
						return;
					}
					callback(false, error);
				},
			);
	}

	private parseErrors(error, callback) {
		if (error.status == 401) {
			return;
		}
		const errorFull = error.error;
		if (typeof error.error == 'object') {
			let error_msg = '';
			for (const [key, value] of Object.entries(error.error)) {
				error_msg += `${key}: ${value}<br>`;
			}
			error.error = error_msg;
		}
		callback(false, error, errorFull);
	}

	getChecked(filters, parameters = null): string {
		let checked = '';
		for (const key in filters) {
			if (typeof filters[key] == 'boolean') {
				checked += filters[key] ? '&' + key + '=1' : '&' + key + '=0';
				continue;
			}
			if (typeof filters[key] == 'number') {
				checked += '&' + key + '=' + filters[key];
				continue;
			}
			if (!filters[key]) {
				continue;
			}
			if (Array.isArray(filters[key])) {
				if (!parameters || !filters[key].length) {
					continue;
				}
				const objects = [];
				filters[key].forEach((obj, index) => {
					if (!obj) {
						return;
					}
					objects.push(obj);
				});
				checked += '&' + key + '=' + objects;
				continue;
			}
			checked += '&' + key + '=' + filters[key];
		}
		return checked.replace(/^&/, '');
	}
}
